import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import Banner from 'components/Banner';
import DistributionContacts from 'components/DistributionContacts';
import bannerImage from 'images/contacts-banner.jpg';
import ContactsCards from './ContactsCards';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';

const Contacts = () => {
    return (
        <>
            <Banner title="Contacts" image={bannerImage} buttonText="Contact us" />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>We’re international</LabelButton>
                        <GradientText>
                            UniferX is growing rapidly <br /> in <em>Germany, Ukraine, Moldova & Kazakhstan</em>
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                Our professional team is always open for communication and ready to help you solve any
                                issue!
                            </GradientText>
                        </div>
                    </div>
                </div>
            </section>

            <DistributionContacts />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>Contacts</LabelButton>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="middle">
                                Service center for <em>Eastern Europe and Central Asia:</em>
                            </GradientText>
                        </div>
                    </div>
                    <ContactsCards />
                </div>
            </section>

            <DefaultForm />
        </>
    );
};

export default Contacts;
